import { publicEnv } from '@config/publicEnv';
import type { Middleware } from 'openapi-fetch';
import createClient from 'openapi-fetch';

import type { paths } from './schema';

function gatewayBaseUrl(): string {
  const url = publicEnv.PNC_UI_API_URL_API_GATEWAY;
  if (!url) {
    console.error(
      'Missing gateway URL: set `PNC_UI_API_URL_API_GATEWAY` in runtime config or a known `APP_ENVIRONMENT` (see `src/config/environmentDefaults.ts`).'
    );
  }
  return (url || '').replace(/\/$/, '');
}

const loggingMiddleware: Middleware = {
  onResponse({ request, response }) {
    console.debug(`${request.url} - ${response.status}`);
  },
  onError({ error }) {
    console.error('OpenAPI fetch request failed', error);
  }
};

export const httpClient = createClient<paths>({
  baseUrl: gatewayBaseUrl(),
  headers: {
    'Content-Type': 'application/json'
  }
});

httpClient.use(loggingMiddleware);
